import _ from 'lodash';
import { HIDE_TOAST, SHOW_TOAST, ToastAction } from 'store/ui/toasts/toastsActions';
import { IToast } from 'store/ui/toasts/toastsTypes';
import {
  DATA_ENTITY_SELECTED,
  HIDE_BACKDROP,
  SANDBOX_CLOSE,
  SANDBOX_OPEN,
  SANDBOX_SET_PENDING,
  SET_PAGE_FILTER,
  SHOW_BACKDROP,
  SHOW_UPGRADABLE_MOCK_SERVICES,
  SWITCH_WORKSPACE,
  TOGGLE_DD_PANEL_OPEN,
  TOGGLE_START_MOCKING_BANNER,
  UPDATE_START_MOCKING_BANNER,
} from 'constants/action-types';
import { SwitchWorkspace } from 'store/transactions/transactionsActionTypes';
import { SetPageFilterAction } from 'store/ui/pageFilters/pageFilterActions';
import { PageFilterContent } from 'store/ui/pageFilters/pageFilterTypes';
import { SetDataEntitySelectedAction, ToggleOpenDDPanelAction } from './ddActions';
import { BackdropActionsActions, ShowUpgradableMocksAction } from 'store/ui/backdrop/backdropActions';
import {
  ToggleStartMockingPanelAction,
  UpdateStartMockingPanelAction,
} from './startMockingBanner/startMockingBannerActions';
import { SandboxAction, SandboxCloseAction, SandboxOpenAction, SandboxSetPendingAction } from './sandboxActions';
import { Transaction } from 'types/rest/assetCatalogTypes';

export interface UiState {
  toasts: IToast[];
  backdrop: {
    visible: boolean;
    text: string;
  };
  pageFilter: PageFilterContent;
  isDDPanelOpened: boolean;
  showUpgradableMockOnly: boolean;
  showStartMockingBanner: boolean;
  isShowLoading: boolean;
  dataEntitySelected: string | undefined;
  sandboxPendingTransaction: Transaction | null;
  sandboxOpenTransaction: Transaction | null;
}

const DEFAULT_STATE: UiState = {
  toasts: [],
  backdrop: {
    visible: false,
    text: '',
  },
  showUpgradableMockOnly: false,
  isShowLoading: false,
  pageFilter: {
    searchTerm: '',
    serviceId: 0,
  },
  showStartMockingBanner: true,
  isDDPanelOpened: false,
  dataEntitySelected: undefined,
  sandboxPendingTransaction: null,
  sandboxOpenTransaction: null,
};

type ActionType =
  | ToastAction
  | SetPageFilterAction
  | SwitchWorkspace
  | ToggleOpenDDPanelAction
  | SetDataEntitySelectedAction
  | BackdropActionsActions
  | ToggleStartMockingPanelAction
  | UpdateStartMockingPanelAction
  | ShowUpgradableMocksAction
  | SandboxAction
  | { type: '' };

export const uiReducer = (state: UiState = DEFAULT_STATE, action: ActionType): UiState => {
  switch (action.type) {
    case HIDE_TOAST:
      let toasts = _.cloneDeep(state.toasts);
      toasts = toasts.filter((toast: IToast) => toast.timestamp !== action.toast.timestamp);
      return {
        ...state,
        toasts: toasts,
      };
    case SHOW_TOAST:
      return {
        ...state,
        toasts: [...state.toasts, action.toast],
      };
    case SET_PAGE_FILTER:
      return {
        ...state,
        pageFilter: action.payload,
      };

    case SWITCH_WORKSPACE:
      return DEFAULT_STATE;
    case TOGGLE_DD_PANEL_OPEN:
      return {
        ...state,
        isDDPanelOpened: !state.isDDPanelOpened,
      };
    case DATA_ENTITY_SELECTED:
      return {
        ...state,
        dataEntitySelected: action.payload,
      };
    case SHOW_BACKDROP:
      return {
        ...state,
        backdrop: {
          visible: true,
          text: action.text || '',
        },
      };
    case HIDE_BACKDROP:
      return {
        ...state,
        backdrop: {
          visible: false,
          text: '',
        },
      };
    case SHOW_UPGRADABLE_MOCK_SERVICES:
      return {
        ...state,
        showUpgradableMockOnly: !state.showUpgradableMockOnly,
      };
    case TOGGLE_START_MOCKING_BANNER:
      return {
        ...state,
        showStartMockingBanner: !state.showStartMockingBanner,
      };
    case UPDATE_START_MOCKING_BANNER: {
      return { ...state, showStartMockingBanner: action.payload };
    }
    case SANDBOX_SET_PENDING:
      return { ...state, sandboxPendingTransaction: (action as SandboxSetPendingAction).payload };
    case SANDBOX_OPEN:
      return {
        ...state,
        sandboxOpenTransaction: (action as SandboxOpenAction).payload,
        sandboxPendingTransaction: null,
      };
    case SANDBOX_CLOSE:
      return { ...state, sandboxOpenTransaction: null };
    default:
      return state;
  }
};

export default uiReducer;
